import { PageHeader } from '@ashniva/ui';

import { CardsSkeleton } from '../../../shared/components/LoadingSkeletons';
import { useRiSettingsQuery } from '../api';
import { NoAccess } from '../components/NoAccess';
import { OrganizationRepositories } from '../components/OrganizationRepositories';
import { ProblemNotice } from '../components/ProblemNotice';
import { SettingsForm } from '../components/SettingsForm';
import { useRepositoryIntelligenceAccess } from '../ri-access';

import '../repository-intelligence.css';

/**
 * Repository Intelligence for administrators (MASTER-SPEC §14.4 entry point 2; P14-01, P14-02): the organization's
 * switches and every linked repository with its state. Who changed a switch and when is in the audit history, under
 * "Repository Intelligence".
 */
export function RepositoryIntelligenceSettingsPage() {
  const access = useRepositoryIntelligenceAccess();
  if (!access.manage) {
    return <NoAccess />;
  }
  return <Loaded />;
}

function Loaded() {
  const settings = useRiSettingsQuery();
  return (
    <div className="ri-page">
      <PageHeader
        title="Repository Intelligence"
        subtitle="Search, read and ask about the code of linked repositories, and analyse changes."
      />
      {settings.isLoading ? <CardsSkeleton label="the settings" cards={1} /> : null}
      {settings.isError ? (
        <ProblemNotice error={settings.error} onRetry={() => void settings.refetch()} />
      ) : null}
      {settings.data ? <SettingsForm settings={settings.data} /> : null}
      <OrganizationRepositories />
    </div>
  );
}
